export default __webpack_public_path__ + "static/media/practice-level-5.7662c4b7.svg";